import { render, staticRenderFns } from "./TruckDetails.vue?vue&type=template&id=55e6386e&scoped=true&"
import script from "./TruckDetails.vue?vue&type=script&lang=js&"
export * from "./TruckDetails.vue?vue&type=script&lang=js&"
import style0 from "./TruckDetails.vue?vue&type=style&index=0&id=55e6386e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6386e",
  null
  
)

export default component.exports